module.exports = __webpack_public_path__ + "static/media/menuBackgroundGreen.e2bd37cd.svg";